import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { get_backlog_insights, get_intm_backlog_intermediate_status } from '../../redux/po_backlog/backlog.selector';
import BarChart from '../../common/components/Chart/StackedBarChart';
import FlipCard from './components/FlipCard';

const Insights = (category) => {
  const backlog_insights = useSelector((state) => {
    return get_backlog_insights(state, category);
  });
  const backlog_intermediate_status = useSelector((state) => {
    return get_intm_backlog_intermediate_status(state, category);
  });
  console.log({ backlog_insights, backlog_intermediate_status });
  return (
    <Box className="grid grid-cols-4 gap-2 p-4">
      <Box className="col-span-4 grid grid-cols-5 gap-2">
        <Box className="col-span-4 sm:col-span-2 flex justify-center items-center h-[250px] rounded-lg">
          {/* <Typography>SLA Overall Number</Typography> */}
          <FlipCard category={`sla`} />
        </Box>
        {/* <Box className="col-span-4 sm:col-span-1 flex justify-center items-center h-[250px] bg-gray-300 rounded">
          <Typography>SLA Table</Typography>
        </Box> */}
        <Box className="col-span-4 sm:col-span-1 flex justify-center items-center h-[250px] bg-gray-300 rounded">
          <Typography>OTIF</Typography>
        </Box>
        <Box className="col-span-4 sm:col-span-1 flex justify-center items-center h-[250px] bg-gray-300 rounded">
          <Typography>Productivity Overall Number</Typography>
        </Box>
        <Box className="col-span-4 sm:col-span-1 flex justify-center items-center h-[250px] bg-gray-300 rounded">
          <Typography>Productivity Table</Typography>
        </Box>
      </Box>
      <Box className="col-span-4">
        <Typography variant="h5" gutterBottom align="left">Received & Released Rate Analysis of In-Process</Typography>
        <Paper className='p-2'>
          <BarChart height="250px" />
        </Paper>
      </Box>
      <Box className="col-span-4">
        <Typography variant="h5" gutterBottom align="left">Received & Released Rate Analysis of INTM</Typography>
        <Paper className='p-2'>
          <BarChart height="250px" />
        </Paper>
      </Box>
      <Box className="col-span-4">
        <Typography variant="h5" gutterBottom align="left">Received & Released Rate Analysis of FP Pack</Typography>
        <Paper className='p-2'>
          <BarChart height="250px" />
        </Paper>
      </Box>
      {/* <Box className="flex justify-center items-start">
        <Container className='p-2'>
          <Box className="grid grid-cols-3 gap-4">
            <Box className="col-span-2 border rounded flex flex-col justify-center items-center p-2" component={Paper}>
              <Box className="w-full">
                {
                  backlog_intermediate_status.loading ?
                    <Box className="h-full w-full flex flex-col justify-center items-center">
                      <CircularWithValueLabel />
                      <Typography>Updating your chart...</Typography>
                      <Box>
                      </Box>
                    </Box> :
                    backlog_insights && backlog_insights.aging_histogram &&
                    <HistogramChart
                      title={"Age Histogram Chart"}
                      series={backlog_insights.aging_histogram.series}
                      categories={backlog_insights.aging_histogram.categories}
                      colors={backlog_insights.aging_histogram.colors}
                      x_axis_title="Age Ranges"
                      y_axis_title="Count in each age category"
                    />
                }

              </Box>
            </Box>
            <Box className='p-2'>
              {
                backlog_insights && backlog_insights.sample_status &&
                <SampleStatus enable_filtering={true} />
              }
            </Box>
            {
              backlog_insights && backlog_insights?.filtered_table_by_sample_status && backlog_insights?.filtered_table_by_sample_status?.length > 0 &&
              <Box className="col-span-3">
                <TableFromArrayOfObjects array={backlog_insights.filtered_table_by_sample_status} />
              </Box>
            }
            <Box className="col-span-3" component={Paper}>
              {
                backlog_insights && backlog_insights.daywise_completion_rate_histogram &&
                <HistogramChart
                  title={"Daywise Completion Rate"}
                  series={backlog_insights.daywise_completion_rate_histogram.series}
                  categories={backlog_insights.daywise_completion_rate_histogram.categories}
                  // colors={backlog_insights.daywise_completion_rate_histogram.colors}
                  x_axis_title="Dates"
                  y_axis_title="Tests Completed"
                />
              }
            </Box>
            <Box className="col-span-3" component={Paper}>
              {
                backlog_insights && backlog_insights.daywise_sampling_receive_rate_histogram &&
                <HistogramChart
                  title={"Daywise Sampling Receive Rate"}
                  series={backlog_insights.daywise_sampling_receive_rate_histogram.series}
                  categories={backlog_insights.daywise_sampling_receive_rate_histogram.categories}
                  // colors={backlog_insights.daywise_sampling_receive_rate_histogram.colors}
                  x_axis_title="Dates"
                  y_axis_title="Samples Received"
                />
              }
            </Box>
            <Box className="col-span-3" component={Paper}>
              {
                backlog_insights && backlog_insights.daywise_sampling_receive_rate_histogram &&
                <ExpiryBarChart
                  series={backlog_insights.daywise_sampling_receive_rate_histogram.series}
                  categories={backlog_insights.daywise_sampling_receive_rate_histogram.categories}
                  // colors={backlog_insights.daywise_sampling_receive_rate_histogram.colors}
                  x_axis_title="Dates"
                  y_axis_title="Samples Received"
                />
              }
            </Box>
          </Box>
        </Container>
      </Box> */}
    </Box>
  );
};

export default Insights;;